import { useEffect, useState, type JSX } from 'react';
import { UnitHeroImageField } from './UnitHeroImageField';
import { UnitGalleryImageField } from './UnitGalleryImageField';
import type { UnitFormErrors, UnitFormState } from './unitFormState';

interface UnitMediaSectionProps {
  propertyId: string;
  formState: UnitFormState;
  errors: UnitFormErrors;
  disabled: boolean;
  isUploadingHero: boolean;
  setFormState: React.Dispatch<React.SetStateAction<UnitFormState>>;
  clearFieldError: (field: keyof UnitFormState) => void;
  onUploadingHeroChange: (uploading: boolean) => void;
}

export function UnitMediaSection({
  propertyId,
  formState,
  errors,
  disabled,
  isUploadingHero,
  setFormState,
  clearFieldError,
  onUploadingHeroChange,
}: UnitMediaSectionProps): JSX.Element {
  const [isUploadingHeroLocal, setIsUploadingHeroLocal] = useState(false);
  const [isUploadingGallery, setIsUploadingGallery] = useState(false);

  useEffect(() => {
    onUploadingHeroChange(isUploadingHeroLocal || isUploadingGallery);
  }, [isUploadingGallery, isUploadingHeroLocal, onUploadingHeroChange]);

  return (
    <div className="flex flex-col gap-6">
      <UnitHeroImageField
        propertyId={propertyId}
        heroImageUrl={formState.heroImageUrl}
        disabled={disabled || isUploadingHero}
        error={errors.heroImageUrl}
        onUploadingChange={setIsUploadingHeroLocal}
        onHeroImageUrlChange={(next) => {
          setFormState((prev) => ({ ...prev, heroImageUrl: next }));
          clearFieldError('heroImageUrl');
        }}
      />
      <UnitGalleryImageField
        propertyId={propertyId}
        galleryImageUrls={formState.galleryImageUrls}
        disabled={disabled || isUploadingHero}
        error={errors.galleryImageUrls}
        onUploadingChange={setIsUploadingGallery}
        onGalleryImageUrlsChange={(updater) => {
          setFormState((prev) => ({
            ...prev,
            galleryImageUrls: updater(prev.galleryImageUrls),
          }));
          clearFieldError('galleryImageUrls');
        }}
      />
    </div>
  );
}
